import React from 'react'
import { shallow } from 'enzyme'
import SmartRateWrapper from '../SmartRateWrapper'

describe('<SmartRateWrapper />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      loanId: 1,
      parentComponent: '',
      data: {
        error: undefined,
        loading: true
      }
    }
  })
  it('should not error when it is loading or there is an error and there is no loan', () => {
    shallow(<SmartRateWrapper {...props} />)
  })
})
